export enum ORDER_BY {
	ASC = "ASC",
	DESC = "DESC"
}
